import { createElement, forwardRef } from 'react';

const CustomTag = forwardRef(({ tag = 'div', children, ...props }, ref) => {
  return createElement(tag, { ...props, ref }, children);
});

export default CustomTag;
